import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1eb251c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-block" }
const _hoisted_2 = { class: "filter-block__title-text textHidden" }
const _hoisted_3 = {
  key: 0,
  class: "filter-block__count"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "filter-block__category none-Mobile" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "textHidden" }
const _hoisted_8 = {
  key: 0,
  class: "filter-block__count"
}
const _hoisted_9 = { class: "mb--20 only-mobile" }
const _hoisted_10 = {
  key: 1,
  class: "filter-block__notFound container"
}
const _hoisted_11 = { class: "filter-block__btns" }
const _hoisted_12 = {
  key: 1,
  class: "filter-block__notFound container"
}
const _hoisted_13 = { class: "filter-block-closeIcon" }

import { computed, onMounted, Ref, ref, watch } from 'vue';
import { ParamType, useSearchRealEstateStore } from '@/store/modules/searchRealEstate';
import { useAppStore } from '@/store/modules/app';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import qs from 'qs';
import { useRouter } from 'vue-router';
import { SearchParamsDataType } from '@/types';
import ParamsBlock from '@/components/MainPageComponents/FilterBlock/ParamsBlock/ParamsBlock.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBlock',
  props: {
    isFilterByTerritory: { type: Boolean },
    showCoordinates: { type: Boolean },
    showListBlock: { type: Boolean, default: true }
  },
  emits: ['close', 'showResultBlock'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const windowWidth = computed((): number => {
  return useAppStore().window;
});
const router = useRouter();

const categories = computed(() => {
  if (props.isFilterByTerritory) {
    return useSearchRealEstateStore().filterCategories.filter(
      el => el.id !== 2 && el.id !== 4 && el.id !== 1,
    );
  }

  return useSearchRealEstateStore().filterCategories;
});

const paramsValues: Ref<SearchParamsDataType> = ref({});
const isLoading = ref(false);
const isShowFilterModal = computed(() => {
  return useOfferCardsStore().isShowFilterModal;
});

const activeCategoryId: Ref<undefined | number> = ref(undefined);
const getActiveGroups = (categoryId: number) => {
  activeCategoryId.value = categoryId;
  const activeGroups = useSearchRealEstateStore().getGroups(categoryId);

  if (activeGroups) {
    getVisibleParams(activeGroups[0].id);
  }
};

const activeGroupId: Ref<undefined | number> = ref(undefined);
const activeParams: Ref<ParamType[] | undefined> = ref(undefined);
const visibleParameters: Ref<number[]> = ref([1]);

const getCountByCategoryId = (categoryId: number | string) => {
  let count = 0;

  const groups = useSearchRealEstateStore().getGroups(categoryId);

  if (groups) {
    groups.forEach(group => {
      const params = useSearchRealEstateStore().getParameters(group.id);

      params?.forEach(el => {
        el.optionsIds.forEach(option => {
          const value = paramsValues.value[option];

          if (value && (value.min || value.max || value.value)) {
            count++;
          }
        });
      });
    });
  }

  return count;
};

const getCountByGroupId = (groupId: number) => {
  let count = 0;
  const params = useSearchRealEstateStore().getParameters(groupId);

  params?.forEach(el => {
    el.optionsIds.forEach(option => {
      const value = paramsValues.value[option];

      if (value && (value.min || value.max || value.value)) {
        count++;
      }
    });
  });

  return count;
};

const paramsCount = computed(() => {
  return Object.values(paramsValues.value).filter(
    paramValue => paramValue.min || paramValue.max || paramValue.value,
  ).length;
});

const getVisibleParams = (groupId: number) => {
  activeGroupId.value = groupId;
  activeParams.value = useSearchRealEstateStore().getParameters(groupId);
  useSearchRealEstateStore().filterSubGroups.map(el =>
    el.parameters.map(el => el.optionsIds),
  );

  visibleParameters.value = [1];
};

const changeVisibleCategory = (categoryId: number) => {
  const index = visibleParameters.value.findIndex(el => el === categoryId);

  if (index >= 0) {
    visibleParameters.value.splice(index, 1);
  } else {
    visibleParameters.value.push(categoryId);
  }
};
const resetFilters = () => {
  Object.keys(paramsValues.value).forEach(param => {
    paramsValues.value[param] = {
      value: null,
      max: null,
      min: null,
    };
  });
  applyFilters(true);
};
const applyFilters = async (withClose: boolean = false) => {
  Object.entries(paramsValues.value).forEach(param => {
    if (param[1]) {
      useOfferCardsStore().updateParameter(
        param[0],
        useSearchRealEstateStore().getDistanceByOptionId(+param[0]) === 'km' &&
          param[1].value
          ? String(+param[1].value / 1000)
          : param[1].value,
        param[1].min,
        param[1].max,
      );
    }
  });
  const preparedData = {
    page: 1,
    pageSize: 8,
    params: useOfferCardsStore().getPreparedParamsForSend(),
  };
  // Добавляем фильтры в URL
  const str = qs.stringify(useOfferCardsStore().params, {
    arrayFormat: 'brackets',
    skipNulls: true,
    encodeValuesOnly: true,
  });

  await router.push(`?${str}`);

  isLoading.value = true;

  try {
    let searchCoordinates;
    let res;

    if (!props.showListBlock && !props.showCoordinates) {
      useOfferCardsStore().toggleIsShowResultBlock(true);
    }

    if (props.showListBlock || (!props.showListBlock && !props.showCoordinates)) {
      res = await useOfferCardsStore().searchOfferCards(preparedData);
    }

    if (props.showCoordinates) {
      searchCoordinates = await useOfferCardsStore().searchOfferCardsCoordinates({
        params: useOfferCardsStore().getPreparedParamsForSend(),
      });
    }
    if (res || searchCoordinates) {
      emit('showResultBlock');
      if (withClose) {
        emit('close');
      }
    }
  } finally {
    isLoading.value = false;
  }
};

//Создаем значения paramsValues и заполняем уже заполненными параметрами
onMounted(() => {
  const getValue = <T,>(option: number, key: 'value' | 'min' | 'max'): T => {
    if (paramsValues.value[option]) {
      return paramsValues.value[option][key] as unknown as T;
    }
    if ({ ...useOfferCardsStore().params }[option]) {
      return useOfferCardsStore().params[option][key] as unknown as T;
    }

    return null!;
  };

  useSearchRealEstateStore().filterSubGroups.forEach(group => {
    group.parameters?.forEach(parameter => {
      parameter.optionsIds.forEach(option => {
        paramsValues.value[option] = {
          value: getValue(option, 'value'),
          min: getValue(option, 'min'),
          max: getValue(option, 'max'),
        };
      });
    });
  });
});

watch(isShowFilterModal, isOpen => {
  if (isOpen) {
    getActiveGroups(categories.value[0].id);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_button_group = _resolveComponent("base-button-group")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_menu_with_tabs = _resolveComponent("base-menu-with-tabs")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    customModal: true,
    fullScreen: windowWidth.value <= 600,
    "show-modal": isShowFilterModal.value,
    withBackground: false,
    "close-outside": "",
    title: "Фильтры",
    onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close')))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_base_menu_with_tabs, {
          activeComponent: activeCategoryId.value,
          componentBtns: categories.value,
          "hide-title": 600,
          bgColor: "#fff",
          greenMobile: "",
          "mobile-show-all-blocks": "",
          withRadius: "",
          onChangeActiveBtn: _cache[9] || (_cache[9] = ($event: any) => (getActiveGroups($event)))
        }, {
          title: _withCtx((titleProps) => [
            _createElementVNode("div", {
              class: _normalizeClass([{ withCount: getCountByCategoryId(titleProps.data.id) }, "filter-block__title"])
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(titleProps.data.title), 1),
              (getCountByCategoryId(titleProps.data.id))
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(getCountByCategoryId(titleProps.data.id)), 1))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          content: _withCtx((contentProps) => [
            (_unref(useSearchRealEstateStore)().getGroups(contentProps.data))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (
                    _unref(useSearchRealEstateStore)().getGroups(contentProps.data).length > 1
                  )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_base_button_group, {
                            active: contentProps.data,
                            buttons: _unref(useSearchRealEstateStore)().getGroups(contentProps.data),
                            btnHeight: "40",
                            textKey: "title",
                            type: "greenBorder",
                            onChangeActiveBtn: _cache[0] || (_cache[0] = ($event: any) => (getVisibleParams($event.id)))
                          }, {
                            btnText: _withCtx((btnTextProps) => [
                              _createElementVNode("div", {
                                class: _normalizeClass([{ withCount: getCountByGroupId(btnTextProps.data.id) }, "filter-block__title"])
                              }, [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(btnTextProps.data.title), 1),
                                (getCountByGroupId(btnTextProps.data.id))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(getCountByGroupId(btnTextProps.data.id)), 1))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["active", "buttons"])
                        ]))
                      : _createCommentVNode("", true),
                    (activeParams.value)
                      ? (_openBlock(), _createBlock(ParamsBlock, {
                          key: 1,
                          modelValue: paramsValues.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paramsValues).value = $event)),
                          "active-params": activeParams.value,
                          "visible-parameters": visibleParameters.value,
                          onChangeVisibleCategory: _cache[2] || (_cache[2] = ($event: any) => (changeVisibleCategory($event))),
                          onChangeDistance: _cache[3] || (_cache[3] = ($event: any) => (
                    activeGroupId.value
                      ? _unref(useSearchRealEstateStore)().changeDistance(
                          activeGroupId.value,
                          $event.id,
                          $event.value,
                        )
                      : () => {}
                  ))
                        }, null, 8, ["modelValue", "active-params", "visible-parameters"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(useSearchRealEstateStore)().getGroups(contentProps.data), (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id
                      }, [
                        _createElementVNode("div", null, [
                          (_unref(useSearchRealEstateStore)().getParameters(item.id))
                            ? (_openBlock(), _createBlock(ParamsBlock, {
                                key: 0,
                                modelValue: paramsValues.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((paramsValues).value = $event)),
                                "active-params": _unref(useSearchRealEstateStore)().getParameters(item.id),
                                "visible-parameters": visibleParameters.value,
                                onChangeVisibleCategory: _cache[5] || (_cache[5] = ($event: any) => (changeVisibleCategory($event))),
                                onChangeDistance: ($event: any) => (
                        item.id
                          ? _unref(useSearchRealEstateStore)().changeDistance(
                              item.id,
                              $event.id,
                              $event.value,
                            )
                          : () => {}
                      )
                              }, null, 8, ["modelValue", "active-params", "visible-parameters", "onChangeDistance"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_10, " Фильтры не найдены "))
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (paramsCount.value > 0)
                      ? (_openBlock(), _createBlock(_component_base_button, {
                          key: 0,
                          disabled: isLoading.value,
                          text: `Сбросить (${paramsCount.value})`,
                          height: "36",
                          "style-type": "coloredBorder",
                          width: "130",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (resetFilters()))
                        }, null, 8, ["disabled", "text"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_base_button, {
                      loading: isLoading.value,
                      height: "36",
                      text: "Применить",
                      width: "130",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (applyFilters(true)))
                    }, null, 8, ["loading"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, "Фильтры не найдены")),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_base_icon, {
                clickable: "",
                color: "black",
                height: "15",
                name: "close",
                width: "15",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
              })
            ])
          ]),
          _: 1
        }, 8, ["activeComponent", "componentBtns"])
      ])
    ]),
    _: 1
  }, 8, ["fullScreen", "show-modal"]))
}
}

})